<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Warply_Field_Endpoint')"
        prop="params.endpoint"
      >
        <el-input
          v-model="model.params.endpoint"
          placeholder="https://warp.ly"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Warply_Field_Username')"
        prop="params.alias"
      >
        <el-input v-model="model.params.username" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Warply_Field_Password')"
        prop="params.password"
      >
        <el-input v-model="model.params.password" type="password" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Warply_Field_AppUUID')"
        prop="params.partner_id"
      >
        <el-input v-model="model.params.appuuid" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Warply_Field_Languages')"
        prop="params.languages"
      >
        <el-select v-model="model.params.languages" multiple filterable>
          <el-option
            v-for="(language, code) in languages"
            :key="code"
            :label="language"
            :value="code"
          />
        </el-select>
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { isValidUrl } from '@/core/helpers'
import { languages } from '@/modules/campaign-manage/enum/LanguagesEnum'

export default {
  name: 'WarplySettings',

  components: {
    FormSection,
    RestFormItem
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    let validateUrl = (rule, value, callback) => {
      if (isValidUrl(value)) {
        callback()
      } else {
        callback(new Error(this.urlValidationMessage))
      }
    }
    return {
      urlValidationMessage: this.$t('RestForm_FieldInvalidUrl'),
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          endpoint: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              validator: validateUrl
            }
          ],
          username: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          password: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          appuuid: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          languages: [
            {
              type: 'array',
              required: true,
              message: this.$t('RestForm_FieldIsRequired'),
              trigger: 'blur'
            }
          ]
        }
      },
      languages
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/warply/WarplySettings.vue